import {TagProps} from 'antd';

import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {
    AiMonitoringAnswerModelStatusEnum,
    AiMonitoringSentimentEnum,
} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

// The best position a brand can take in an answer; shown apart from the rest of the top.
export const LEADER_POSITION = 1;

// Highest position still counted as "top" — 1..3 are highlighted, anything below is neutral.
export const MAX_TOP_POSITION = 3;

export const SENTIMENT_TAG_COLOR_MAP: Record<AiMonitoringSentimentEnum, TagProps['color']> = {
    [AiMonitoringSentimentEnum.positive]: 'green',
    [AiMonitoringSentimentEnum.neutral]: 'default',
    [AiMonitoringSentimentEnum.negative]: 'red',
};

export const SENTIMENT_LANG_KEY_MAP: Record<AiMonitoringSentimentEnum, LangKeyType> = {
    [AiMonitoringSentimentEnum.positive]: 'AI_BRAND_MONITORING__ANSWERS__SENTIMENT_POSITIVE',
    [AiMonitoringSentimentEnum.neutral]: 'AI_BRAND_MONITORING__ANSWERS__SENTIMENT_NEUTRAL',
    [AiMonitoringSentimentEnum.negative]: 'AI_BRAND_MONITORING__ANSWERS__SENTIMENT_NEGATIVE',
};

// Statuses that mean the model never produced a usable answer, so the row is excluded from scoring.
export const EXCLUDED_ANSWER_MODEL_STATUSES: ReadonlySet<AiMonitoringAnswerModelStatusEnum> = new Set([
    AiMonitoringAnswerModelStatusEnum.error,
    AiMonitoringAnswerModelStatusEnum.skipped,
]);
